// Add your custom JS here.
(function($){
    $(function(){
        // Get the text field
        var copyBtn = document.getElementById('copy');
        $(copyBtn).on('click', function(){
            var copyTarget = this.dataset.copy;
            var copyText = document.getElementById(copyTarget);
    
            // Copy the text inside the text field
            //navigator.clipboard.writeText(copyText.innerText);

            navigator.clipboard.write([new ClipboardItem({
                'text/plain': new Blob([copyText.innerText], {type: 'text/plain'}),
                'text/html': new Blob([copyText.outerHTML], {type: 'text/html'})
              })])
    
            // Alert the copied text
            var message = document.getElementById(this.dataset.message);
            if (message) {
                message.innerHTML = "Link copied to clipboard!";
            }
        });

        
      $( '.gf_readonly' ).find( 'input, select, textarea' ).each(
        function() {
            $( this ).prop( 'readonly', true );
      });
  

    });
})(jQuery);